import { joinChannel } from './ws-actions';
import { getForumChannel } from '../services/ws-channel';

export function emitForumOpened() {
  return joinChannel(getForumChannel());
}



// WEBPACK FOOTER //
// ./app/actions/forum-socket.js